import React from 'react';
import { RichText } from '../RichText';
import { company } from '../../data/company';
const principles = [{
  title: 'Digital by design',
  text: 'Every resource is built to be delivered and used electronically, with no shipping or waiting for physical materials.'
}, {
  title: 'Made for real use',
  text: 'Our materials are created for instructors and professionals who need resources they can put to work.'
}, {
  title: 'Clear policies',
  text: 'Delivery, refunds, and privacy are explained in plain language before you purchase.'
}];
export function AboutSection() {
  const info = [['Legal name', company.legalName], ['State of registration', company.stateOfRegistration], ['Business address', company.address]];
  return <section id="about" aria-labelledby="about-heading" className="scroll-mt-16 border-t border-line bg-canvas" data-id="element-63" data-mp="379wpom7huh6c">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 md:py-20 lg:grid-cols-[2fr_1fr]" data-id="element-64" data-mp="8ntw37tn582v">
        <div className="max-w-2xl" data-id="element-65" data-mp="1ldi59j8b4s2k">
          <h2 id="about-heading" className="font-serif text-3xl font-semibold tracking-tight text-ink" data-id="element-66" data-mp="1lejhvs4z1mme">About Tracker Group LLC</h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-67" data-mp="1qbs17w1uvwp8">
            Tracker Group LLC develops digital learning materials for instructors and professionals and makes them available for purchase online.
          </p>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-68" data-mp="1gkfd9fj6hqoh">
            Our goal is simple: give coaches well-organized, practical material they can use right away, so planning takes minutes instead of hours.
          </p>

          <div className="mt-10 space-y-6" data-id="element-69" data-mp="spcjqu9fiz1o">
            {principles.map(p => <div key={p.title} className="grid gap-2 border-t border-line pt-6 sm:grid-cols-[200px_1fr] sm:gap-8" data-id="element-70" data-mp="xnw9z6v22wzu">
                <h3 className="font-semibold text-ink" data-id="element-71" data-mp="2n2c8pdzp95lm">{p.title}</h3>
                <p className="leading-relaxed text-muted" data-id="element-72" data-mp="2n115bfa61zv1">{p.text}</p>
              </div>)}
          </div>
        </div>

        <aside aria-labelledby="company-info" className="h-fit rounded-xl border border-line bg-paper p-6" data-id="element-73" data-mp="2qlb1l0msevhk">
          <h3 id="company-info" className="font-serif text-xl font-semibold text-ink" data-id="element-74" data-mp="2llf31gwuzw9e">Company information</h3>
          <dl className="mt-5 space-y-4 text-sm" data-id="element-75" data-mp="2gndbs8pa4qmu">
            {info.map(([label, value]) => <div key={label} data-id="element-76" data-mp="2bok632g8i3x8">
                <dt className="text-muted" data-id="element-77" data-mp="2bplltk873ela">{label}</dt>
                <dd className="mt-1 font-medium text-ink" data-id="element-78" data-mp="39bj0f6jgezry"><RichText text={value} data-id="element-79" data-mp="39dc5wiibzdyd" /></dd>
              </div>)}
          </dl>
        </aside>
      </div>
    </section>;
}